import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BrandedRouter } from '../../services/brandedRouter';
import { ConfigService } from '../../services/configuration.service';
import { ThreatMetrixService } from '../../services/threat-metrix.service';
import { ThreatMetrixComponent } from '../../components/threat-metrix/threat-metrix.component';
import { LoginComponent } from '../../components/login/login.component';
import { LoginSCAComponent } from '../../components/login-sca/login-sca.component';
import { LoginJourney } from '../../components/login-sca/login-sca-enums';
import { NonSCAStoreStaffCardsService } from '../../services/strong-customer-authentication/non-SCA-store-staff-cards.service';
import {
  LoggedOutEntitlement,
  LoggedOutEntitlementsService,
} from '../../services/logged-out-entitlements.service';

@Component({
  selector: '[login]',
  templateUrl: './login.component.html',
})
export class LoginPageComponent implements OnInit, OnDestroy {
  @ViewChild('loginComponent') loginComponent: LoginComponent;
  @ViewChild('loginSCAComponent') loginSCAComponent: LoginSCAComponent;
  @ViewChild('threatMetrixComponent')
  threatMetrixComponent: ThreatMetrixComponent;
  public loadingEntitlements = true;
  public threatMetrixEnabled = false;
  public loginUrl: string = '#';
  public registerUrl: string = '#';
  public isMobileView = true;
  public scaEnabled = false;
  public registrationAllowed: boolean;
  private ngUnsubscribe = new Subject<void>();
  public redirectToNonSCA: boolean = false;
  public systemError = '';
  private readonly generalSystemErrorMessage =
    'We are currently experiencing some technical difficulties. We’re aware of the problem and we’re working hard to resolve it as soon as possible. Please try again later.';

  constructor(
    private readonly brandedRouter: BrandedRouter,
    private readonly configService: ConfigService,
    private readonly threatMetrixService: ThreatMetrixService,
    private readonly loggedOutEntitlementsService: LoggedOutEntitlementsService,
    private nonSCAStoreStaffCardsService: NonSCAStoreStaffCardsService
  ) {
    this.loginUrl = this.brandedRouter.getBrandedLink('login');
    this.registerUrl = this.brandedRouter.getBrandedLink('register');
    this.isMobileView = this.configService.Get('mobileView');
  }

  ngOnInit() {
    this.loadEntitlements();
    this.nonSCAStoreStaffCardsService.isNonScaLoginJourney
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (isNonScaLoginJourney) => (this.redirectToNonSCA = isNonScaLoginJourney)
      );
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private async loadEntitlements() {
    try {
      const threatMetrixLoginEnabled =
        await this.loggedOutEntitlementsService.hasEntitlement(
          LoggedOutEntitlement.threatMetrixLogin
        );

      this.threatMetrixService.setEntitlement(
        'Login',
        threatMetrixLoginEnabled
      );
      this.threatMetrixEnabled =
        this.threatMetrixService.enabled && threatMetrixLoginEnabled;

      this.scaEnabled = await this.loggedOutEntitlementsService.hasEntitlement(
        LoggedOutEntitlement.scaLogin
      );
      this.registrationAllowed =
        await this.loggedOutEntitlementsService.hasEntitlement(
          LoggedOutEntitlement.registrationPages
        );
      this.loadingEntitlements = false;
    } catch {
      this.systemError = this.generalSystemErrorMessage;
    }
  }

  public clickLink(e: MouseEvent, url: string): void {
    e.preventDefault();

    if (!url || url.length === 0) return;

    if (url === 'login' && this.loginComponent) {
      this.loginComponent.step = 1;
      return;
    }

    if (url === 'login' && this.loginSCAComponent) {
      this.loginSCAComponent.step = LoginJourney.Username;
      return;
    }

    this.brandedRouter.navigate(url);
  }
}
